import { render, staticRenderFns } from "./InformacionGeneralForm.vue?vue&type=template&id=78e59256&scoped=true&"
import script from "./InformacionGeneralForm.vue?vue&type=script&lang=js&"
export * from "./InformacionGeneralForm.vue?vue&type=script&lang=js&"
import style0 from "./InformacionGeneralForm.vue?vue&type=style&index=0&id=78e59256&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e59256",
  null
  
)

export default component.exports